import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=966473ee&scoped=true&"
import script from "./Multiple.vue?vue&type=script&lang=js&"
export * from "./Multiple.vue?vue&type=script&lang=js&"
import style0 from "./Multiple.vue?vue&type=style&index=0&id=966473ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966473ee",
  null
  
)

export default component.exports